import http from 'helpers/APIHelper';
import { httpStatusEnum } from 'appconstants';
import { map } from 'rxjs/operators';
import { getSessionByKey } from 'helpers';
import { suffixPending, suffixFulfilled, suffixRejected } from 'actions';

export const PSRS_ACTIONS = {
  GET_PSRS: '@protocol/psrs/getpsrs',
  GET_PSRS_AFFILIATION: '@protocol/psrs/getPsrAffiliation',
  SET_PSR_INDEX: '@protocol/psrs/setPsrIndex',
  SET_SELECTED_PSR: '@protocol/psrs/setSelectedPsr',
  GET_VERIFIED_BY: '@protocol/psrs/verifiedby',
  GET_AFFILIATIONS_HISTORY: '@protocol/psrs/affiliationshistory'
};

export const setPsrIndex = psrIndex => dispatch => {
  const action = {
    type: PSRS_ACTIONS.SET_PSR_INDEX,
    payload: psrIndex
  };
  dispatch(action);
};

export const setSelectedPsr = psr => dispatch => {
  const action = {
    type: PSRS_ACTIONS.SET_SELECTED_PSR,
    payload: psr
  };
  dispatch(action);
};


export const getPsrs = (token, loggerInfo, id, postBody = {
  sort: [{ field: 'seq', value: 'asc' }]
}) => dispatch => {
  dispatch({
    type: PSRS_ACTIONS.GET_PSRS + suffixPending
  });
  http
    .postWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/number/${id}/psrs`,
      token,
      loggerInfo,
      JSON.stringify(postBody)
    )
    .subscribe(
      resp => {
        dispatch({
          type: PSRS_ACTIONS.GET_PSRS + suffixFulfilled,
          payload: resp.response
        });
      },
      error => {
        dispatch({
          type: PSRS_ACTIONS.GET_PSRS + suffixRejected,
          payload: error
        });
      }
    );
};

export const getPsrsAffiliation = (
  token,
  loggerInfo,
  id,
  psrId
) => dispatch => {
  dispatch({
    type: PSRS_ACTIONS.GET_PSRS_AFFILIATION + suffixPending
  });
  http
    .postWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/number/${id}/psrs/${psrId}/affiliations`,
      token,
      loggerInfo
    )
    .subscribe(
      resp => {
        dispatch({
          type: PSRS_ACTIONS.GET_PSRS_AFFILIATION + suffixFulfilled,
          payload: resp.response
        });
      },
      error => {
        dispatch({
          type: PSRS_ACTIONS.GET_PSRS_AFFILIATION + suffixRejected,
          payload: error
        });
      }
    );
};


export const setEmptyPsrAffiliation = psrIndex => dispatch => {
  const action = {
    type: PSRS_ACTIONS.GET_PSRS_AFFILIATION + suffixFulfilled,
    payload: {}
  };
  dispatch(action);
};

export const savePsrsAffiliation = (
  token,
  loggerInfo,
  id,
  postBody,
  psrId
) => (dispatch, getState) => http
  .putWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/id/${id}/psrs/${psrId}/affiliations`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  )
  .pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(getPsrsAffiliation(
          token,
          loggerInfo,
          getState().prtDetails.prtInfo.protocolNumber,
          psrId
        ));
      }
      return resp;
    })
  );

export const savePSR = (token, loggerInfo, id, postBody) => (
  dispatch,
  getState
) => http
  .putWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/id/${id}/psrs`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  ).pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(
          getPsrs(
            token,
            loggerInfo,
            getState().prtDetails.prtInfo.protocolNumber
          )
        );
      }
      return resp;
    })
  );

export const changeSequence = (token, loggerInfo, prtId, psrID, direction) => (
  dispatch,
  getState
) => {
  http
    .putWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/id/${prtId}/psrs/${psrID}/sequence/${direction}`,
      token,
      loggerInfo
    )
    .subscribe(
      resp => {
        dispatch(getPsrs(
          token,
          loggerInfo,
          getState().prtDetails.prtInfo.protocolNumber
        ));
      }
    );
};

export const deletePsrAffiliation = (token, loggerInfo, prtId, psrId, affilId) => (
  dispatch,
  getState
) => http
  .deleteWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/id/${prtId}/psrs/${psrId}/affiliations/${affilId}`,
    token,
    loggerInfo
  ).pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(
          getPsrsAffiliation(
            token,
            loggerInfo,
            getState().prtDetails.prtInfo.protocolNumber,
            psrId
          )
        );
      }
      return resp;
    })
  );


export const getCheckValueForVerifiedByAction = (token, loggerInfo, paramKey) => (dispatch, getState) => {
  dispatch({
    type: PSRS_ACTIONS.GET_VERIFIED_BY + suffixPending
  });
    return http
    .get(
      `core-service/${getSessionByKey(
        "prt_url_ver"
      )}/core/apps/PROTOCOL/params/${paramKey}`
    );
};

export const getAffiliationsHistory = (token, loggerInfo, psrId) => (dispatch) => {
  dispatch({
    type: PSRS_ACTIONS.GET_AFFILIATIONS_HISTORY + suffixPending
  });
  http
    .getWithToken(
      `protocol-data-service/${getSessionByKey(
        "prt_url_ver"
      )}/protocols/psrs/${psrId}/affiliations/history`,
      token,
      loggerInfo
    )
    .subscribe(
      (resp) => {
        dispatch({
          type: PSRS_ACTIONS.GET_AFFILIATIONS_HISTORY + suffixFulfilled,
          payload: resp.response
        });
      },
      (error) => {
        dispatch({
          type: PSRS_ACTIONS.GET_AFFILIATIONS_HISTORY + suffixRejected,
          payload: error
        });
      }
    );
};